








import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class TextArea extends Vue {
    @Prop() private value!: string;

    @Prop({default: ""}) private placeholder!: string;
    @Prop({default: 2}) private row!: string;
    @Prop({default:100}) private maxLength!:number;

    get textValue() {
        return this.value;
    }

    set textValue(text: string) {
        this.$emit("change", text);
    }
}
